import React, { FC, useEffect, useState } from 'react';
import { Icon } from '@/components/atomic/Icon';
import Toast from '@/components/Toast';
import { UserStatusOnClickWrapper } from '@/userStatus/components';
import { classnames } from '@/utils/classnames';

export interface IHamiUserBalanceRefetchProps {
  refetch: () => {};
  isFetching: boolean;
  isError: boolean;
  showBalance: boolean;
  isMasked?: boolean;
  onMaskChange?: (__isMasked: boolean) => void;
}

const HamiUserBalanceRefetch: FC<IHamiUserBalanceRefetchProps> = ({
  isMasked,
  isFetching,
  refetch,
  onMaskChange,
  showBalance,
  isError,
}) => {
  const [shouldFetch, setShouldFetch] = useState(false);
  const [seconds, setSeconds] = useState(0);

  useEffect(() => {
    const timer =
      seconds > 0 && setInterval(() => setSeconds(seconds - 1), 1000);
    if (timer) return () => clearInterval(timer);
  }, [seconds]);

  useEffect(() => {
    if (!isFetching && seconds === 0) {
      if (shouldFetch === true)
        Toast.open({
          variant: 'info',
          children: `موجودی با موفقیت بروزرسانی شد.`,
        });
      setShouldFetch(false);
    }
  }, [isFetching, seconds]);

  return (
    <>
      {!isError && showBalance && (
        <UserStatusOnClickWrapper>
          <div
            className="z-50 flex h-8 w-8 cursor-pointer items-center justify-center rounded-[8px] border border-solid border-[#fff] "
            onClick={() => onMaskChange?.(!isMasked)}
          >
            <Icon
              icon={!isMasked ? 'visibility_off_outline' : 'visibility_outline'}
              size={20}
            />
          </div>

          <div
            className={classnames(
              `disabled first-letter z-50 mr-5 flex h-8 w-8 cursor-pointer items-center justify-center rounded-[8px] border border-solid border-[#fff]`,
              (isFetching || seconds > 0) && 'cursor-not-allowed opacity-30'
            )}
            onClick={() => {
              if (!isFetching && seconds === 0) {
                setSeconds(2);
                setShouldFetch(true);
                refetch();
              }
            }}
          >
            <Icon
              className={classnames(
                ((isFetching && shouldFetch) || seconds > 0) && 'animate-spin'
              )}
              icon={'refresh'}
              size={20}
            />
          </div>
        </UserStatusOnClickWrapper>
      )}
    </>
  );
};
export { HamiUserBalanceRefetch };
